<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">交易流程</div>
        <img src="@/assets/ment/333/11/1.png" alt="" />
        <p>1.1 二维码解析</p>
        <span
          >概述：此接口用于客户归属运营商解析二维码信息<br />
          接口名称：query_parse_qrcode<br />
          接口使用方法：聚能实现此接口，客户归属运营商服务平台调用</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/2.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/3.png" alt="" />
        <p>1.2 设备认证</p>
        <span
          >概述：概述：此接口用于客户归属运营商服务平台请求充电基础设施的认证信息<br />
          接口名称：query_equip_auth<br />
          接口使用方法：聚能和基础设施运营商实现此接口，客户归属运营商服务平台调用聚能，聚能调用基础设施运营商</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/4.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/5.png" alt="" />
        <p>1.3 查询计费业务策略信息</p>
        <span
          >概述：1）用于客户归属运营商服务平台向聚能查询充电桩业务策略信息 
           2）聚能向基础设施运营商查询充电桩业务策略信息<br />
          接口名称：query_equip_business_policy<br />
          接口使用方法：聚能和基础设施运营商实现该接口，客户归属运营商服务平台方调用聚能，聚能调用基础设施运营商。启动充电前用户运营方务必调用一次并展现给用户，以确保拿到最新的价格，避免拉取桩站信息不及时造成客诉</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/6.png" alt="" />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/7.png" alt="" />
        <small>单项业务策略信息体参数：</small>
        <img src="@/assets/ment/333/11/8.png" alt="" />
        <span
          >聚能对用户运营商返回的参数中，如存在其他不在上述定义的字段，请忽略即可</span
        >
        <p>1.4 启动充电</p>
        <span
          >概述：1）此接口用于客户归属运营商请求聚能启动充电
          2）聚能向基础设施运营商请求启动充电<br />
          接口名称：query_start_charge<br />
          接口使用方法：聚能和基础设施运营商实现此接口，客户归属运营商服务平台方调用聚能，聚能调用基础设施运营商</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/9.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/10.png" alt="" />
        <p>1.5 推送启动充电结果</p>
        <span
          >概述：该接口用于接收启动结果<br />
          接口名称：notification_start_charge_result<br />
          接口使用方法：客户归属运营商和聚能实现此接口，基础设施运营商调用聚能，
          聚能调用客户归属运营商</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/11.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/12.png" alt="" />
        <p>1.6 查询充电状态</p>
        <span
          >概述：此接口用于客户归属运营商请求聚能充电订单状态信息,或者聚能请求设备运营方查询订单信息。聚能会在未收到notification_charge_order_info接口推送的情况下主动调用本接口查询订单，故需要保证通过本接口在充电结束后48小时内也可以查到订单数据</br>
接口名称：query_equip_charge_status</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/13.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/14.png" alt="" />
         <small>充电明细信息表：</small>
        <img src="@/assets/ment/333/11/15.png" alt="" />

        <p>1.7 推送充电状态</p>
        <span
          >概述：此接口用于聚能向客户归属运营商平台推送订单充电状态，受设备归属运营商推送时间粒度影响，部分设备归属运营商不会推送该信息，建议不要完全依赖该接口进行订单状态流转<br/>
接口名称：notification_equip_charge_status<br/>
接口使用方法：由客户归属运营商实现此接口，聚能调用</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/16.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/17.png" alt="" />

        <p>1.8 请求停止充电</p>
        <span
          >概述：客户归属运营商请求聚能停止充电<br />
接口名称：query_stop_charge<br />
接口使用方法：由聚能实现此接口，客户归属运营商平台调用</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/18.png" alt="" />
        <!-- <small>返回值：</small>
        <img src="@/assets/ment/333/11/19.png" alt="" /> -->

        <p>1.9 推送停止充电结果</p>
        <span
          >概述：此接口用于聚能向客户归属运营商平台推送停止充电结果信息，本接口可选，停止充电的状态判断主要依赖推送订单信息接口。</br>
接口名称：notification_stop_charge_result</br>
接口使用方法：客户归属运营商平台实现此接口，聚能调用</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/22.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/19.png" alt="" />

        <p>1.10 推送充电订单账单信息</p>
        <span>概述：此接口用于聚能向客户归属运营商推送充电订单账单信息<br/>
接口名称：notification_charge_order_info<br/>
接口使用方法：由客户归属运营商服务平台实现此接口，聚能调用</span><br/>
        <small>请求参数：</small>
        <img src="@/assets/ment/333/11/20.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/11/21.png" alt="" />

        <p>1.10.1 金额计算规则</p>
        <span>注：金额的四舍五入应在充电信息明细中进行<br/> </span>
        <ul>
            <li><span class="line"></span><span>【3 位小数 DetailPower】*【4 位小数 ElecPrice】，再四舍五入得【2 位小数 DetailElecMoney】</span></li>
            <li><span class="line"></span><span>【3 位小数 DetailPower】*【4 位小数 SevicePrice】，再四舍五入得【2 位小数 DetailSeviceMoney】</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span> 各个时段的 DetailElecMoney 相加得 TotalElecMoney</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span> 各个时段的 DetailSeviceMoney 相加得 TotalSeviceMoney</span></li>
        </ul>
        <br/>

       

        <p>1.10.2 账单的推送时间</p>
        <ul>
            <li><span class="line"></span>&nbsp;&nbsp;<span>国网作为设备运营商时，订单账单最晚可能到开始时间之后 168 小时才推送
</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span>其他运营商作为设备运营商时，订单最晚可能到开始时间之后 48 小时才推送
</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span>如果上述时间之内设备运营商推送了金额，应以设备运营方金额为准
</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span> 如果上述时间之后还未推送，用户运营商应主动查询一次订单状态（query_equip_charge_status），并以此次查询到的结果作为与设备运营方的结算依据
</span></li>
            <li><span class="line"></span>&nbsp;&nbsp;<span> 如果在此时间以内，用户运营商希望向用户收费，应根据订单计费策略、充电时间、度数等参数自行计算收费金额，需自行承担设备运营商推送账单和向用户收费之间的差额</span></li>
        </ul>
        <br/>
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>
.home_con_index {
  display: flex;
  text-align: left;
 
}
.mentCon small {
  margin: 23px 0px 12px 0px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 12px;
}
.mentCon img {
  margin: 0px;
}
ul li {
  display: flex;
}
ul li .line {
  width: 3px;
  height: 3px;
  margin-top: 9px;
  border-radius: 5px;
  background: #5a6073;
  display: block;
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentf.vue